import { styled } from "styled-components";
import { SwiperCarousel, SwiperSlide } from "./Swiper";
import SearchspringProductTile from "./SearchspringProductTile";
import { buttonReset, colors, font } from "../lib/sharedStyles";
import { useSearchContext } from "../contexts/SearchContext";

const CarouselContainer = styled.div`
  swiper-slide {
    height: auto;

    > div {
      height: 100%;
    }
  }
`;

const CarouselHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 24px;

  @media (min-width: 1024px) {
    padding-bottom: 16px;
  }

  > h2 {
    ${font('Futura', 600, '24px', '24px')};
    letter-spacing: -0.48px;
    color: ${colors.fender.primaryDark};
    margin: 0;
  }
`;

const Navigation = styled.div`
  display: flex;
  gap: 8px;

  button {
    ${buttonReset()};
    width: 32px;
    height: 32px;
    transition: background-color 0.2s ease, border-radius 0.2s ease;
    cursor: pointer;
  
    &:hover {
      background-color: #f5f5f5;
      border-radius: 100%;
    }
    cursor: pointer;

    svg {
      vertical-align: middle;
    }

    // Rotate "next" arrow
    &:not(:first-of-type) {
      svg {
        transform: rotate(180deg);
      }
    }
  
    // This class is dynamically added by Swiper.
    &.swiper-button-disabled {
      svg path {
        fill: #E5E5E5;
      }
    }
  }
`;

const swiperParams = {
  breakpoints: {
    768: {
      enabled: false,
      slidesPerView: 4,
      slidesOffsetAfter: 0,
    }
  },
  keyboard: { 
    enabled: true, 
    onlyInViewport: true
  },
  slidesOffsetAfter: 16,
  slidesOffsetBefore: 16,
  slidesPerView: 1.95,
  spaceBetween: 8,
};

const SearchFlyoutProductCarousel = () => {
  const { products, carouselHeadingText } = useSearchContext();
  // These attributes are needed to display correct pricing in EMEA
  const localeDataEl = document.getElementById('basic-modal-entry');
  const shopLocale = localeDataEl?.dataset.shopLocale;
  const shopMarket = localeDataEl?.dataset.shopMarket;
  const regionDataEl = document.getElementById('react-jwt-all');
  const siteRegion = regionDataEl?.dataset.region;

  const navigation = {
    prevEl: `.swiper-button-prev-search-flyout-carousel`,
    nextEl: `.swiper-button-next-search-flyout-carousel`,
  };

  return (
    <div>
      <CarouselHeader>
        <h2>{carouselHeadingText}</h2>
        <Navigation>
          {Object.keys(navigation).map(key => (
            // @ts-ignore untyped object, substring to remove leading "."
            <button key={key} className={navigation[key].substring(1)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path fill='#191A1F' d="M11 6.988a.75.75 0 0 0 0-1.5v1.5ZM.47 5.708a.75.75 0 0 0 0 1.06l4.773 4.774a.75.75 0 1 0 1.06-1.061L2.061 6.238l4.242-4.242A.75.75 0 0 0 5.243.935L.47 5.708ZM11 5.488H1v1.5h10v-1.5Z"/></svg>
            </button>
          ))}
        </Navigation>
      </CarouselHeader>
      <CarouselContainer>
        <SwiperCarousel {...swiperParams} navigation={navigation}>
          {products.map(product => (
            <SwiperSlide key={product.id}>
              <SearchspringProductTile
                layout="grid"
                locale={shopLocale || 'en'}
                shopMarket={shopMarket}
                region={siteRegion}
                // @ts-ignore
                product={product}
                context="searchFlyout"
              />
            </SwiperSlide>
        ))}
        </SwiperCarousel>
      </CarouselContainer>
    </div>
  );
}

export default SearchFlyoutProductCarousel;